import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS, REACT_APP_AHA_PILOT_WIDGET } from '../../constants';
import { createIconWithPath} from 'cdk-radial';
import { TextButton } from '../Buttons/TextButton';
import { useTheme } from '../../contexts/Theme';
import { useTranslation } from 'react-i18next';
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';

export function AhaPilotWidget() {
  const { trackEvent } = useAnalytics();
  const { darkMode } = useTheme();
  const {t} = useTranslation();
  const ahaPilotFlag = useFeatureFlag('UNIFY_UI_AHA_PILOT');

  const handleAhaWidget = () => {
      trackEvent(AMPLITUDE_EVENTS.HEADER_ITEM_SELECTED,{'Item': 'Join a Pilot'})
      const aha = window.aha;
      aha && aha('open', REACT_APP_AHA_PILOT_WIDGET);
  };

  const PilotIcon = createIconWithPath([{
    d: "M10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0ZM6.72754 10.2861C5.68879 10.2861 4.08169 10.5599 2.83398 11.1045C3.36658 14.5822 6.37443 17.2498 10 17.25C10.8614 17.25 11.6883 17.0985 12.4551 16.8223V13.0361C12.4551 11.2055 8.63402 10.2862 6.72754 10.2861ZM13.8467 10.7568C13.6334 10.7568 13.3464 10.79 13.0947 10.8291C13.9481 11.6851 14.0937 12.4598 14.0938 13.2314V15.9814C15.632 14.926 16.7433 13.2933 17.1143 11.3965C16.0312 10.9715 14.7173 10.757 13.8467 10.7568ZM13.8457 5.09961C12.6234 5.09966 11.6367 6.04786 11.6367 7.22168C11.6369 8.39539 12.6235 9.34272 13.8457 9.34277C15.0678 9.34259 16.0477 8.39531 16.0479 7.22168C16.0479 6.04794 15.0679 5.09979 13.8457 5.09961ZM6.72754 4C5.3694 4.00004 4.27344 5.05316 4.27344 6.35742C4.27359 7.66155 5.36949 8.71382 6.72754 8.71387C8.08546 8.71369 9.17367 7.66147 9.17383 6.35742C9.17383 5.05325 8.08556 4.00018 6.72754 4Z",
    fillRule: "evenodd",
    fill: darkMode ? 'white' : 'black'
  }]);

  return (
        <div className="right" data-testid="aha-widget-plt" > 
        {
        ahaPilotFlag && 
          <TextButton
            icon={<PilotIcon  />} 
            text={t('header.joinPilot')}
            darkMode={darkMode} 
            onClick={handleAhaWidget}
            style={{ fontSize: "14px", fontWeight: "500", fontFamily:'Montserrat' }} id={'aha-widget'}/>
        }
        </div>  
  );
}
